/**
 * Created by sswaminathan on 1/26/22
 * File: DualNetworkAddonListing
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body, Bold } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import {
  ADDONS_LABEL, ADEM_MOBILE_NETWORK_LABEL, ADEM_REMOTE_NETWORK_LABEL,
} from '../../constants/SubscriptionConstant'
import DualInputComponent from './sections/DualInputComponent'
import SectionHeaders from './sections/SectionHeaders'

const DualNetworkAddonListing = ({ allocation, dualNetworkAddons, dualNetworkKeys, ...rest }) => {
  return (<>
    <div className='tw-flex tw-flex-row tw-ml-2'>
      <div style={{ 'flex-basis': '42%' }}>
        <SectionHeaders headers={ADDONS_LABEL} />
      </div >
      <div style={{ 'flex-basis': '66%' }}>
        <div className='tw-flex tw-flex-row tw-py-6'>
          <div style={{ 'flex-basis': '30%' }}>
            <Body size='xs'><Bold>{ADEM_MOBILE_NETWORK_LABEL}</Bold></Body>
          </div>
          <div className='tw-flex-1'>
            <Body size='xs'><Bold>{ADEM_REMOTE_NETWORK_LABEL}</Bold></Body>
          </div>
        </div>
      </div>
    </div>
    {dualNetworkKeys.map((app_id, idx) => {
      return <DualInputComponent key={idx} {...{ dualNetworkAddons, allocation, app_id, ...rest }}/>
    })
    }
  </>)
}
export default DualNetworkAddonListing

